import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import CheckBox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

class ApplicationsTable extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BootstrapTable
        containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
        headerStyle={{
          borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
          , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
        }}

        data={this.props.data}>
       <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "App Name"}}
          isKey={true}dataField="appName">App<br/>Name</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Emp Id"}}
          dataField="empID">Emp Id</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Emp Name"}}
          dataField="empName">Emp<br/>Name</TableHeaderColumn>
        <TableHeaderColumn
          dataFormat={(cell,row,na,rowId)=>{
              if(row.empCreatedDate!= null) {
                return row.empComments +' - '+ new Date(row.empCreatedDate).toDateString();
              } else {
               return row.empComments;
              }
            }}
          dataField="empComments">Emp<br/>Comments</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Manager Name"}}
          dataField="managerName">Manager<br/>Name</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Manger Status"}}
          dataField="managerStatus">Manager<br/>Status</TableHeaderColumn>
        <TableHeaderColumn
          dataFormat={(cell,row,na,rowId)=>{
            if(row.managerModifiedDate!= null) {
              return row.managerComments+' - '+ new Date(row.managerModifiedDate).toDateString();
            } else {
              return row.managerComments;
            }
          }}
          dataField="managerComments">Manager<br/>Comments</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "VH Name"}}
          dataField="vhName">VH<br/>Name</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "VH Status"}}
          dataField= "vhStatus">VH<br/>Status</TableHeaderColumn>
        <TableHeaderColumn
          dataFormat={(cell,row,na,rowId)=>{
            if(row.vhModifiedDate!= null) {
              return row.vhComments +' - '+ new Date(row.vhModifiedDate).toDateString();
            } else {
              return row.vhComments;
            }
          }}
          dataField="vhComments">VH<br/>Comments</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Owner Name"}}
          dataField="ownerName">Owner<br/>Name</TableHeaderColumn>
        <TableHeaderColumn
          filter={{type: "TextFilter", placeHolder: "Owner Status"}}
          dataField="ownerStatus">Owner<br/>Status</TableHeaderColumn>
        <TableHeaderColumn
          dataFormat={(cell,row,na,rowId)=>{
            if(row.ownerModifiedDate!= null) {
                return row.ownerComments +' - '+ new Date(row.ownerModifiedDate).toDateString();
            } else {
               return row.ownerComments;
            }
          }}
          dataField="ownerComments">Owner<br/>Comments</TableHeaderColumn>
      </BootstrapTable>
    );
  }
}

ApplicationsTable.propTypes = {};

export default ApplicationsTable;



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/MyApplications/components/ApplicationsTable.js
 **/